import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";

import IndicatorController from "./IndicatorController";
import VirtualPTVideo from "./VirtualPTVideo";
import FirstVisit from "./FirstVisit";
import DiagnosisToDischarge from "./DiagnosisToDischarge";
import FindYourPath from "./FindYourPath";
import PoweredBy from "./PoweredBy";
import PostMessage from "./PostMessage";

import { callSocket } from "../../../utils/socket";
import VPTFooterButton from "./VPTFooterButton";

function VPTAutoPlaySlider() {
    const [activeSlide, setActiveSlide] = useState(0);
    const [slideStarted, setSlideStarted] = useState(false);
    const [videoControls, setVideoControls] = useState(null);

    let sliderRef = useRef(null);

    const start = () => {
        setSlideStarted(true);
    };

    const play = () => {
        sliderRef?.slickPlay();
    };
    const pause = () => {
        sliderRef?.slickPause();
    };

    const next = () => {
        sliderRef?.slickNext();
    };
    const back = () => {
        sliderRef?.slickPrev();
    };

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        infinite: false,
        beforeChange: (current, next) => {
            setActiveSlide(next);
        },
        swipeToSlide: true,
    };

    useEffect(() => {}, [sliderRef]);

    const goToScheduler = () => {
        callSocket("/interact-native-component", { type: "open-link", link: "https://go.oncehub.com/PTconsult" });
    };

    const [slides, setSlides] = useState([
        <VirtualPTVideo
            mobile={true}
            controls={{ play, pause, next, back, start }}
            setupVideoControls={(videoControls) => {
                setVideoControls(videoControls);
            }}
        />,
        <FirstVisit/>,
        <DiagnosisToDischarge/>,
        <FindYourPath/>,
        <PoweredBy/>,
        // <PostMessage />,
    ]);

    const [slidesProgress, setSlidesProgress] = useState([
        { max: 51000, progress: 0 },
        { max: 5000, progress: 0 },
        { max: 5000, progress: 0 },
        { max: 5000, progress: 0 },
        { max: 5000, progress: 0 },
        // { max: 5000, progress: 0},
    ]);

    return (
        <div id="v-pt-auto-slider" className="slider-container">
            <IndicatorController speed={5000} controls={{ play, pause, next, back }} videoControls={videoControls} slidesProgress={slidesProgress} activeSlide={activeSlide} slideStarted={slideStarted} />

            <Slider ref={(slider) => (sliderRef = slider)} {...settings}>
                {slides.map((slide) => {
                    return slide;
                })}
            </Slider>

            <VPTFooterButton
                title="START TREATMENT"
                action={() => {
                    goToScheduler();
                }}
            />
        </div>
    );
}
export default VPTAutoPlaySlider;
